module.exports = __webpack_public_path__ + "img/qr-code-01.a1f28511.svg";